import { proxy } from 'valtio'
import { derive, devtools } from 'valtio/utils'
import { type ApiCallType } from '../types/ApiCallType'
import { resetProxy } from '../utils/proxyUtils'
import { type GlobalCustomerCardType } from '../types/GlobalCustomerCardType'
import { type GlobalCustomerAchType } from '../types/GlobalCustomerAchType'
import { type GlobalReactSelectOptionStringValueType } from '../types/GlobalReactSelectOptionStringValueType'

export interface CreditCardProxyType {
  apiCallCustomerCardsSearch: ApiCallType
  apiCallCustomerAchSearch: ApiCallType
  customerCards: readonly GlobalCustomerCardType[]
  formattedCards: GlobalReactSelectOptionStringValueType[]
  achAccounts: readonly GlobalCustomerAchType[]
}

const initialValues = {
  achAccounts: [],
  apiCallCustomerAchSearch: {
    error: null,
    loading: false
  },
  apiCallCustomerCardsSearch: {
    error: null,
    loading: false
  },
  customerCards: [],
  formattedCards: []
}

const baseProxy = proxy(initialValues)

export const creditCardListProxy = derive({}, { proxy: baseProxy }) as CreditCardProxyType

devtools(creditCardListProxy, { name: 'creditCardListProxy' })

export const resetCreditCardAddProxy = (): void => {
  resetProxy(initialValues, creditCardListProxy)
}
